import axios, { AxiosError } from 'axios';

type ErrorResponse = SimpleErrorResponse | ErrorResponseV2 | DetailedErrorResponse;

interface SimpleErrorResponse {
  error: string;
  message?: string;
}

export interface ErrorResponseV2Error {
  type: string;
  details?: string;
  message?: string;
}
interface ErrorResponseV2 {
  error: ErrorResponseV2Error;
}

interface DetailedErrorResponse<T = unknown, U = unknown> {
  error: string;
  errorDetails: T;
  errorOptions: U;
}

export const checkAxiosError = (err: unknown): err is AxiosError<ErrorResponse> => axios.isAxiosError(err);

export const checkMaintenanceError = (err: unknown) => {
  return checkAxiosError(err) && err.response && err.response.status === 503 && !err.response.data;
};

export const checkDetailedErrorResponse = <T, U>(err: ErrorResponse): err is DetailedErrorResponse<T, U> => {
  return 'errorDetails' in err || 'errOptions' in err;
};

/**
 * @deprecated Use getErrorCode instead
 */
export const getAxiosError = (err: unknown) => {
  if (!checkAxiosError(err)) return '';
  const resErr = err.response?.data.error;
  if (typeof resErr === 'string') return resErr || '';
  return resErr?.type || '';
};

export const getAPIDetailedError = (err: unknown) => {
  if (!checkAxiosError(err)) return '';
  const resErr = err.response?.data.error;
  if (resErr == null || typeof resErr !== 'object') return '';
  return resErr;
};

export function getDetailedErrorResponse<T>(err: unknown): DetailedErrorResponse<T, never> | undefined;
export function getDetailedErrorResponse<T, U>(err: unknown) {
  if (!checkAxiosError(err)) return;
  const resErr = err.response?.data;
  if (resErr && checkDetailedErrorResponse<T, U>(resErr)) return resErr;
}

export { AxiosError, AxiosHeaders } from 'axios';
